<template>
  <Card>
    <p slot="title">搜索项目</p>
    <div class="search-input" style="max-width:360px;">
      <Input v-model="projectRegisterPrjName"
        placeholder="输入项目名称搜索已确认的项目"
        @on-search="searchProjectRegisters"
        search enter-button="搜索项目" />
    </div>
    <div class="padding-top-20"></div>
    <p class="font-grey small">输入项目关键字搜索已确认《存储通知书》的项目，若没有找到项目，请联系项目所在地监管人员。</p>
    <div class="project-register-list">
      <Table border ref="dataTable"
        size="small"
        stripe
        :columns="projectRegisterColumns"
        :data="projectRegisterData">
      </Table>
    </div>
    <Modal v-model="projectRegisterDetailModal"
      title="详情"
      width="900"
      :okText="'选择'"
      :mask-closable="false"
      @on-ok="select"
      @on-cancel="cancel"
      >
      <div class="project-register-detail" v-if="projectRegisterDetail&&projectRegisterDetail.orderNumber">
        <div class="detail-header">
          <div class="status-badge">
            <Tag :color="$common.projectRegisterStatusColor[projectRegisterDetail.status]">
              {{$common.projectRegisterStatus[projectRegisterDetail.status]}}
            </Tag>
          </div>
          <div class="order-number">
            <h2>
              {{projectRegisterDetail.orderNumber}}
            </h2>
            <div class="font-grey">单据号:{{ projectRegisterDetail.serialNo }}</div>
          </div>
        </div>
        <table class="brief-table">
          <tbody>
            <tr>
              <td class="title">地区</td>
              <td>
                {{ projectRegisterDetail.cityName }}
              </td>
              <td class="title">行业/领域</td>
              <td>
                {{ projectRegisterDetail.industryName }}
              </td>
              <td class="title">保证金监管方</td>
              <td>
                {{ projectRegisterDetail.supervisorName }}
              </td>
            </tr>
            <tr>
              <td class="title">项目名称</td>
              <td colspan="5">
                {{ projectRegisterDetail.projectName }}
              </td>
            </tr>
            <tr>
              <td class="title">工程地址</td>
              <td colspan="3">
                {{ projectRegisterDetail.projectSite }}
              </td>
              <td class="title">结构形式</td>
              <td>
                {{ projectRegisterDetail.projectStruc }}
              </td>
            </tr>
            <tr>
              <td class="title">中标价(元)</td>
              <td>
                {{ projectRegisterDetail.projectCost.toLocaleString() }}
                <div class="small font-grey">{{$common.transformNumberIntoCHS(projectRegisterDetail.projectCost)}}</div>
              </td>
              <td class="title">建设规模</td>
              <td>
                {{ projectRegisterDetail.projectScale }}
              </td>
              <td class="title">开竣工日期(计划)</td>
              <td>
                {{ $moment(projectRegisterDetail.projectStartDate).format('YYYY-MM-DD') }} 至 {{ $moment(projectRegisterDetail.projectEndDate).format('YYYY-MM-DD') }}
              </td>
            </tr>
            <tr>
              <td class="title">建设单位名称</td>
              <td>
                {{ projectRegisterDetail.ownerName }}
              </td>
              <td class="title">负责人</td>
              <td>
                {{ projectRegisterDetail.ownerManager }}
              </td>
              <td class="title">联系电话</td>
              <td>
                {{ projectRegisterDetail.ownerManagerTel }}
              </td>
            </tr>
            <tr>
              <td class="title">施工总包单位名称</td>
              <td>
                {{ projectRegisterDetail.contractorName }}
              </td>
              <td class="title">项目经理</td>
              <td>
                {{ projectRegisterDetail.contractorManager }}
              </td>
              <td class="title">联系电话</td>
              <td>
                {{ projectRegisterDetail.contractorManagerTel }}
              </td>
            </tr>
            <tr>
              <td class="title">存储基数(元)</td>
              <td>
                {{ projectRegisterDetail.payableBase.toLocaleString()  }}
                <div class="small font-grey">{{$common.transformNumberIntoCHS(projectRegisterDetail.payableBase)}}</div>
              </td>
              <td class="title">应存储金额(元)</td>
              <td>
                {{ projectRegisterDetail.payableAmount.toLocaleString()  }}
                <div class="small font-grey">{{$common.transformNumberIntoCHS(projectRegisterDetail.payableAmount)}}</div>
              </td>
              <td class="title">存储比例(%)</td>
              <td>
                {{ projectRegisterDetail.payableRatio * 100 }}%
              </td>
            </tr>
            <tr>
              <td class="title">存储方式</td>
              <td>
                {{ projectRegisterDetail.method ? '现金' : '保函' }}
              </td>
              <td class="title">保证金经办人</td>
              <td>
                {{ projectRegisterDetail.opName }}
              </td>
              <td class="title">经办人电话</td>
              <td>
                {{ projectRegisterDetail.opTel }}
              </td>
            </tr>
            <tr>
              <td class="title">经办机构名称</td>
              <td>
                {{ projectRegisterDetail.guarantorName }}
              </td>
              <td class="title">联系人</td>
              <td>
                {{ projectRegisterDetail.guarantorContact }}
              </td>
              <td class="title">电话</td>
              <td>
                {{ projectRegisterDetail.guarantorTel }}
              </td>
            </tr>
            <tr>
              <td class="title">地址</td>
              <td colspan="5">
                {{ projectRegisterDetail.guarantorAddress }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </Modal>
  </Card>
</template>

<script>
export default {
  name: 'project-register-selector',
  data () {
    return {
      projectRegisterPrjName: null,
      projectRegisterData: [],
      projectRegisterPageIndex: 1,
      projectRegisterColumns: [
        {
          title: '单据号',
          width: 160,
          key: 'serialNo',
          resizable: true,
        },
        {
          title: '业务编号',
          width: 160,
          key: 'orderNumber',
          resizable: true,
        },
        {
          title: '状态',
          key: 'status',
          width: 120,
          render: (h, params) => {
            return h('Tag', {
              props: {
                color: this.$common.projectRegisterStatusColor[params.row.status.toString()]
              }
            }, this.$common.projectRegisterStatus[params.row.status.toString()])
          }
        },
        {
          title: '项目名称',
          width: 240,
          key: 'projectName',
          resizable: true,
        },
        {
          title: '建设单位',
          width: 240,
          key: 'ownerName',
          resizable: true,
        },
        {
          title: '施工单位',
          width: 240,
          key: 'contractorName',
          resizable: true,
        },
        {
          title: '监管单位',
          width: 240,
          key: 'supervisorName',
          resizable: true,
        },
        {
          title: '中标金额',
          key: 'projectCost',
          width: 120,
          render: (h, params) => {
            return h('span', {}, params.row.projectCost ? Math.round(params.row.projectCost / 100 / 1000) / 10 + '万' : null)
          }
        },
        {
          title: '存储比例',
          key: 'payableRatio',
          width: 120,
          render: (h, params) => {
            return h('span', {}, Math.round(params.row.payableRatio * 10000) / 100 + '%')
          }
        },
        {
          title: '上报时间',
          key: 'createTime',
          width: 120,
          render: (h, params) => {
            return h('span', {}, params.row.createTime ? this.getMoment(params.row.createTime).format('YYYY-MM-DD') : null)
          }
        },
        {
          title: '操作',
          width: 160,
          fixed: 'right',
          render: (h, params) => {
            return h('span', null, [
              h('Tooltip', {
                props: {
                  content: '选择',
                  transfer: true
                },
                style: {
                  marginLeft: '5px'
                }
              }, [
                h('Button', {
                  props: {
                    type: 'primary',
                    ghost: true,
                    shape: 'circle',
                    icon: 'md-checkmark'
                  },
                  on: {
                    click: () => {
                      this.projectRegisterDetail = params.row
                      this.projectRegisterDetailModal = true
                    }
                  }
                }, null),
              ]),
            ])
          }
        }
      ],
      projectRegisterDetail: null,
      projectRegisterDetailModal: false,
    }
  },
  methods: {
    getMoment (dt) {
      return this.$moment(dt)
    },
    searchProjectRegisters (name) {
      this.$Api.ProjectRegister.listProjectRegisters({
        projectName: name,
        status: 1
      }, 1, -1).then((res) => {
        this.projectRegisterData = res.data
        this.projectRegisterPageIndex = res.currentPage
      })
    },
    cancel () {
      this.projectRegisterDetailModal = false
      this.$emit('cancel')
      this.projectRegisterDetail = null
    },
    select () {
      this.$Modal.confirm({
        title: '确认操作',
        content: '<p>确认选择该项目么？</p>',
        onOk: () => {
          this.$emit('select', this.projectRegisterDetail)
          this.cancel()
        },
        onCancel: () => {
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.project-register-detail {
  .detail-header {
    margin-bottom: 20px;
    position: relative;
    .status-badge {
      position: absolute;
      right: 0;
      top: 0;
    }
    .header-actions {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-end;
    }
  }
}
</style>